import { useTranslation } from "react-i18next";
import type { RiskLevel } from "../../lib/api.js";

const STYLES: Record<RiskLevel, { color: string; bg: string; dot: string }> = {
  high: { color: "var(--risk-high)", bg: "var(--risk-high-bg)", dot: "#F04E4E" },
  medium: { color: "var(--risk-medium)", bg: "var(--risk-med-bg)", dot: "#F59E0B" },
  low: { color: "var(--risk-low)", bg: "var(--risk-low-bg)", dot: "#22C55E" },
};

export function RiskBadge({ level }: { level: RiskLevel }) {
  const { t } = useTranslation();
  const s = STYLES[level];
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-medium"
      style={{ color: s.color, background: s.bg }}
    >
      <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: s.dot }} />
      {t(`risk.${level}`)}
    </span>
  );
}
